import React from "react";
import { Row, Col, Card, Button, Popconfirm } from "antd";
import EditLinkButton from "../../../Common/ClaimComponents/Button/EditLinkButton";
import { DEFAULT_GUTTER } from "../../../constants/ui";
import { CloseOutlined } from "@ant-design/icons";
import { If } from "../../../Common/ui";
import { formatDueDescription } from "./pay-schedule.helpers";

const PayScheduleBasicDetails = (props: any) => {
  const {
    data,
    edit,
    claims,
    claimComponent,
    hasNoComponents,
    handleDelete,
    deleteComponent,
  } = props;
  return (
    data && (
      <Card
        title="Pay Schedule Details"
        bordered={false}
        extra={
          <If
            condition={claimComponent}
            then={
              <>
                <EditLinkButton
                  onClick={edit}
                  name={claimComponent}
                  claims={claims}
                  hasNoComponents={
                    hasNoComponents === undefined ? true : hasNoComponents
                  }
                />
                <If
                  condition={deleteComponent}
                  then={
                    <Popconfirm
                      placement="bottomLeft"
                      title="Are you sure you want to delete this pay schedule?"
                      onConfirm={() => handleDelete()}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        type="link"
                        className="color-danger button-link rounded-[20px]"
                      >
                        <CloseOutlined />
                        Delete
                      </Button>
                    </Popconfirm>
                  }
                />
              </>
            }
            else={<React.Fragment />}
          />
        }
        className="card"
      >
        <Row className="p-1" gutter={DEFAULT_GUTTER}>
          <Col md={14}>
            <ul className="list-unstyled mb-0">
              <li>
                <b>Amendments Due</b> <br />
                {formatDueDescription(
                  data.amendmentDueInDays,
                  data.amendmentDueTime,
                )}
              </li>
              <li>
                <b>Pay Run Preparation Due</b> <br />
                {formatDueDescription(
                  data.payRunPreparationDueInDays,
                  data.payRunPreparationDueTime,
                )}
              </li>
              <li>
                <b>Approval Due</b> <br />
                {formatDueDescription(
                  data.approvalDueInDays,
                  data.approvalDueTime,
                )}
              </li>
              <li>
                <b>Finalise Due</b> <br />
                {formatDueDescription(
                  data.finaliseDueInDays,
                  data.finaliseDueTime,
                )}
              </li>
            </ul>
          </Col>
          <Col md={10}>
            <ul className="list-unstyled mb-0">
              <li>
                <b>Business Model:</b> <br />
                {data.payrollModel}
              </li>
              <li>
                <b>Payment Due:</b> <br />
                {formatDueDescription(
                  data.paymentDueInDays,
                  data.paymentDueTime,
                )}
              </li>
            </ul>
          </Col>
        </Row>
      </Card>
    )
  );
};

export default PayScheduleBasicDetails;
